/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { TravelDraft } from '../../models/travel-draft';

export interface TravelControllerGetDraft$Params {
  id: number;
}

export function travelControllerGetDraft(http: HttpClient, rootUrl: string, params: TravelControllerGetDraft$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelDraft;
}>> {
  const rb = new RequestBuilder(rootUrl, travelControllerGetDraft.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TravelDraft;
      }>;
    })
  );
}

travelControllerGetDraft.PATH = '/travel/draft/{id}';
